import { HttpClient } from '@angular/common/http'
import { Injectable } from '@angular/core'
import { environment } from '../../../environments/environment'
import { Observable } from 'rxjs'

@Injectable()
export class ContactTitlesService {
  constructor(private http: HttpClient) {}

  public fetchContactTitles(params: object): Observable<any> {
    const url = `${environment.API_ENDPOINT}/admin/contactTitles`
    return this.http.post(url, params)
  }
  public fetchContactTitle(id: number): Observable<any> {
    const url = `${environment.API_ENDPOINT}/admin/contactTitle/${id}`
    return this.http.get(url, {})
  }

  public deleteContactTitle(id: number): Observable<any> {
    const url = `${environment.API_ENDPOINT}/admin/contactTitle/${id}`
    return this.http.delete(url)
  }

  public createContactTitle(params: object): Observable<any> {
    const url = `${environment.API_ENDPOINT}/admin/contactTitle`
    return this.http.post(url, params)
  }

  public updateContactTitle(id: number, params: object): Observable<any> {
    const url = `${environment.API_ENDPOINT}/admin/contactTitle/${id}`
    return this.http.put(url, params)
  }
}
